import { MenuItem } from '@mui/material';
import {
  CustomAutoComplete,
  CustomSelect,
  CustomTextField,
  CustomButton,
  HorizontalForm,
} from '../../../../common/components';
import RefreshIcon from '@mui/icons-material/Refresh';
import ClearIcon from '@mui/icons-material/Clear';

const statusOptions = [
  { value: '', label: 'Todos' },
  { value: 'not_started', label: 'Sin empezar' },
  { value: 'in_progress', label: 'En progreso' },
  { value: 'completed', label: 'Completado' },
  { value: 'cancelled', label: 'Cancelado' },
];

const ProjectsFilters = ({
  filters,
  allotments = [],
  subcontractors = [],
  onFilterChange,
  onApply,
  onClear,
}) => {
  const allotmentOptions = allotments.map((allotment) => ({
    value: allotment.uuid,
    label: allotment.name || 'Loteo sin nombre',
  }));

  const subcontractorOptions = subcontractors
    .filter(
      (subcontractor) =>
        subcontractor?.is_subcontractor === true || subcontractor?.is_subcontractor === '1'
    )
    .map((subcontractor) => ({
      value: subcontractor.uuid,
      label:
        subcontractor.company ||
        subcontractor.legal_business_name ||
        subcontractor.cuit ||
        'Subcontratista sin nombre',
    }));

  return (
    <HorizontalForm variant='twoRows'>
      <CustomAutoComplete
        label="Loteo"
        name="uuid_allotment"
        value={filters.uuid_allotment}
        onChange={onFilterChange}
        options={allotmentOptions}
        optionValueKey="value"
        optionLabelKey="label"
        placeholder="Todos"
        sx={{ maxWidth: '240px', mr: 1.5 }}
      />
      <CustomAutoComplete
        label="Contratista"
        name="uuid_subcontractor"
        value={filters.uuid_subcontractor}
        onChange={onFilterChange}
        options={subcontractorOptions}
        optionValueKey="value"
        optionLabelKey="label"
        placeholder="Todos"
        sx={{ maxWidth: '240px', mr: 1.5 }}
      />
      <CustomSelect
        label="Estado"
        name="status"
        value={filters.status}
        onChange={onFilterChange}
        sx={{ maxWidth: '160px', mr: 1.5 }}
      >
        {statusOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </CustomSelect>
      <CustomTextField
        label="Contrato"
        name="contract_number"
        value={filters.contract_number}
        onChange={onFilterChange}
        sx={{ maxWidth: '120px', mr: 1.5 }}
      />
      <CustomTextField
        label="Nombre suscriptor"
        name="subscriber_name"
        value={filters.subscriber_name}
        onChange={onFilterChange}
        sx={{ maxWidth: '200px', mr: 1.5 }}
      />
      <CustomButton
        buttonIcon={RefreshIcon}
        variant="base"
        onClick={onApply}
        sx={{ mt: 1.5, mr: 1.5 }}
      />
      <CustomButton
        buttonIcon={ClearIcon}
        variant="warning"
        onClick={onClear}
        sx={{ mt: 1.5 }}
      />
    </HorizontalForm>
  );
};

export default ProjectsFilters;
